module.exports = __webpack_public_path__ + "static/media/crab.ea64f751.png";